import React from "react";
import { Table } from "react-bootstrap";


const StreckTable = ({ data, title, theme }) => {

  return (
    <div className="container streck-table-container">
      <p>{title} - Topp 3 genom tiderna</p>

      <Table striped bordered hover responsive="sm" variant={theme}>
        <thead>
          <tr className="same-col-widths">
            <th>Person</th>
            <th>Antal</th>
          </tr>
        </thead>
        <tbody>
          {data.map(({ _id, person, streck }) => (
            <tr key={_id}>
              <td >{person}</td>
              <td>{streck}</td>
            </tr>))}
        </tbody>
      </Table>
    </div>
  );
}

export default StreckTable;